const normalizeString = function normalizeString(val) {
  const value = val || '';
  return value.toString().trim();
};

export default {
  email() {
    return function emailValidator(value) {
      const re = /^\S+@\S+\.\S+$/;
      if (!re.test(normalizeString(value))) {
        return { error: 'error.INVALID' };
      }

      return false;
    };
  },

  required() {
    return function requiredValidator(val) {
      if (normalizeString(val).length === 0) {
        return { error: 'error.BLANK' };
      }

      return false;
    };
  },

  minLength(minLength) {
    return function minLengthValidator(val) {
      const value = normalizeString(val);

      if (value.length < minLength) {
        return {
          error: 'error.TOO_SHORT',
          meta: { count: minLength },
        };
      }

      return false;
    };
  },

  maxLength(maxLength) {
    return function maxLengthValidator(val) {
      const value = normalizeString(val);
      if (value.length > maxLength) {
        return {
          error: 'error.TOO_LONG',
          meta: { count: maxLength },
        };
      }

      return false;
    };
  },

  acceptance() {
    return function acceptanceValidator(value) {
      if (value !== true) {
        return { error: 'error.ACCEPTED' };
      }

      return false;
    };
  },

  ifNotEmpty(validator) {
    return function ifNotEmptyValidator(value) {
      if (value) {
        return validator(value);
      }

      return false;
    };
  },
};



// WEBPACK FOOTER //
// ./app/utils/validators.js